// extracted by mini-css-extract-plugin
export default {"wrap":"HoverZoomLayeredImage_wrap__gWNEJ","fg":"HoverZoomLayeredImage_fg__sMM2b","bg":"HoverZoomLayeredImage_bg__Hy8OV"};